import { SET_DELETEDRIVER } from '../actions';

const driverdelete = (state = [], action) => {
  switch (action.type) {
	case SET_DELETEDRIVER:
      return [...action.value];  
    default: return state;
  }
}

export default driverdelete;
